import React from "react"
import SEO from "../components/SEO"

const Terms: React.FC = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions | Thecodebazaar"
        description="Terms and conditions for using Thecodebazaar.com themes, digital products, and services."
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-50 to-blue-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900">
            Terms & Conditions
          </h1>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Please read these terms carefully before using our website or
            purchasing any product or service from Thecodebazaar.com
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="container mx-auto px-4 py-14">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-10">

          <p className="text-sm text-gray-500 mb-10">
            Last updated: January 2026
          </p>

          {/* Section Wrapper */}
          <div className="space-y-12 text-gray-700 leading-relaxed">

            {/* Section */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing or using Thecodebazaar.com, you agree to be bound
                by these Terms & Conditions. If you do not agree with any part
                of these terms, please do not use our website or services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                2. About Thecodebazaar
              </h2>
              <p>
                Thecodebazaar.com is a digital platform based in Madhya Pradesh,
                India. We sell website themes, digital products, online
                courses, and provide website development and digital marketing
                services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                3. Products & Services
              </h2>
              <p>
                All products sold on Thecodebazaar.com are digital in nature.
                Product descriptions, pricing, and availability may change at
                any time without prior notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                4. Payments & Pricing
              </h2>
              <p>
                Payments once completed are final. Prices listed on the website
                may change at any time. We reserve the right to refuse or cancel
                any order at our discretion.
              </p>
            </div>

            {/* License Section */}
            <div className="bg-sky-50 border border-sky-100 rounded-xl p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. License & Usage Restrictions
              </h2>
              <p className="mb-4">
                When you purchase a theme or digital product from
                Thecodebazaar.com, you receive a limited, non-transferable
                license subject to the following rules:
              </p>

              <ul className="space-y-3 list-disc list-inside">
                <li>Only the original buyer may use the purchased theme.</li>
                <li>Reselling, sharing, or redistributing the theme is strictly prohibited.</li>
                <li>Modifying the theme and selling or distributing it is not allowed.</li>
                <li>Each license is valid for a single domain only.</li>
                <li>The theme may only be used on the licensed domain.</li>
                <li>Unauthorized use on multiple domains is a violation of this agreement.</li>
                <li>Corporate or client usage is allowed only where explicitly stated.</li>
                <li>License violations may result in termination without refund.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                6. Refund Policy
              </h2>
              <p>
                Digital products such as themes and courses are non-refundable.
                Service-related refunds are handled according to our Refund
                Policy and only under special conditions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                7. Intellectual Property
              </h2>
              <p>
                All content, source code, designs, logos, and products are the
                intellectual property of Thecodebazaar.com and are protected by
                applicable copyright laws.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                8. Disclaimer
              </h2>
              <p>
                All products and services are provided “as is” without warranties
                of any kind. We do not guarantee that our products will be free
                from errors or suitable for every use case.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                9. Limitation of Liability
              </h2>
              <p>
                Thecodebazaar.com shall not be liable for any indirect or
                consequential damages arising from the use of our products or
                services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                10. Changes to Terms
              </h2>
              <p>
                We reserve the right to modify these Terms & Conditions at any
                time. Continued use of the website means you accept the updated
                terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                11. Governing Law
              </h2>
              <p>
                These terms are governed by the laws of India. Any disputes
                shall be subject to the jurisdiction of courts in Madhya
                Pradesh, India.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                12. Contact Information
              </h2>
              <p>
                If you have any questions regarding these Terms & Conditions,
                please contact us through the official contact details
                mentioned on Thecodebazaar.com.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Terms
